module.exports = __webpack_public_path__ + "img/hong_kong.f16fe197.svg";